export default __webpack_public_path__ + "static/media/thermometer-half.17c6b3a0.svg";